export const ERROR_MESSAGE = {
  title: "Something went wrong!",
  detail: (
    <div>
      We encountered an unexpected issue.
      <br />
      <strong>Actionable Steps</strong> Refresh the page: Sometimes a quick
      refresh can resolve the issue, Check your connection: Ensure your internet
      connection is stable, Try again later: The problem might be temporary.
    </div>
  ),
};

export const sheetMessage = (res) => ({
  title: res.message[0],
  detail: res.detailMessage,
});
